import LocalizedStrings from "react-localization";
import langBE from "./language_BE";
import langDE from "./language_DE";
import langEN from "./language_EN";
import langES from "./language_ES";
import langFR from "./language_FR";
import langNL from "./language_NL";
import langPL from "./language_PL";

let nl = langNL;
let domain = ((window.location.hostname || "").split(".") || [])[
  ((window.location.hostname || "").split(".") || []).length - 1
];
if (domain === "be") {
  nl = { ...langNL, ...langBE };
}
const en = langEN;
const de = langDE;
const fr = langFR;
const es = langES;
const pl = langPL;

const strings = new LocalizedStrings({ en, nl, de, fr, es, pl });

const availableLanguages = ["en", "nl", "de", "fr", "es", "pl"];
const userLang = (navigator.language || navigator.userLanguage || "").split(
  "-"
)[0];
if (availableLanguages.includes(userLang)) {
  strings.setLanguage(userLang);
} else {
  strings.setLanguage("en");
}

if (localStorage.getItem("userLanguage")) {
  strings.setLanguage(localStorage.getItem("userLanguage"));
}

export const languages = strings;

export const languageNames = {
  nl: "Nederlands",
  en: "English",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  pl: "Polski",
};

// export const changeLanguage = function(language) {
//   switch (language) {
//     case "en":
//       return { TwoLetter: "en", NativeName: "English" };
//     case "nl":
//       return { TwoLetter: "nl", NativeName: "Nederlands" };
//     default:
//       return { TwoLetter: "en", NativeName: "English" };
//   }
// };

// export const extractAvailableLanguages = function(locs) {
//   return locs.getAvailableLanguages().filter(x => x !== locs.getLanguage());
// };
